const autoNgTemplateLoaderTemplate1 = require('./teamsDatatable.html');

angular.module('portainer.app').component('teamsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    isAdmin: '<',
  },
});
